var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-contents layout-2col1-2"},[_c('PlantingList',{attrs:{"id":_vm.id},on:{"getPlantings":_vm.getPlantings}}),_c('PlantingDetail',{attrs:{"id":_vm.id,"mode":_vm.mode,"plantings":_vm.plantings}}),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }